const prlx = () => {
	if ($('.js-prlx').length) {
		gsap.registerPlugin(ScrollTrigger);
		if (window.innerWidth < 992) {
			return;
		}
		// Vertical parallax effect
		gsap.utils.toArray('.js-prlx').forEach((prlxItem) => {



			// Set parallax speed
			let yEnd = -200;
			let yStart = 50;
			if (prlxItem.classList.contains('js-prlx--speed-2')) {
				yEnd = -300;
			} else if (prlxItem.classList.contains('js-prlx--speed-3')) {
				yEnd = -550;
			}

			// Set parallax rotation
			let startRotation = 0,
				endRotation = 0;
			if (prlxItem.classList.contains('js-prlx--rotate-left')) {
				startRotation = 10;
				endRotation = -5;
			} else if (prlxItem.classList.contains('js-prlx--rotate-right')) {
				startRotation = -5;
				endRotation = 10;
			}

			if (prlxItem.classList.contains('js-prlx--story-1')) {
				yStart = 400;
				yEnd = -100;
			}
			if (prlxItem.classList.contains('js-prlx--story-2')) {
				yStart = 600;
				yEnd = -140;
			}

			// Increase start yPos if parallax item is the basic_image_and_text module's image
			if (prlxItem.parentNode.classList.contains('image-and-text__image')) {
				yStart = 100;
				yEnd = -150;
			}



			gsap.fromTo(
				prlxItem,
				{
					y: yStart,
					rotation: startRotation,
				},
				{
					scrollTrigger: {
						trigger: prlxItem,
						start: 'top bottom',
						end: 'bottom 200px',
						scrub: true, // Give positive integer as value to get more easing/smoothness (e.g. 2,3,4)
						markers: false, // Set to true to add markers to UI to debug.
					},
					y: yEnd,
					rotation: endRotation,
					ease: 'none',
					duration: 3,
				}
			);
		});
	}
};
